import { Box, makeStyles, Theme } from '@material-ui/core'
import React, { FC, useEffect, useState } from 'react'

import CancelIcon from '@material-ui/icons/Cancel';
import InfoIcon from '@material-ui/icons/Info';
import GroupIcon from '@material-ui/icons/Group';
import Rules from './Rules';
import PlayerList from './PlayerList';
import { SOUNDS, useAudio } from './Game/hooks/useAudio';
import { PlayerMeta } from './Game/models/Player.model';
import AudioSettings from '../../shared/AudioSettings';

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		position: 'fixed',
		zIndex: 1024,
		top: 0,
		right: '32px',
		display: 'flex',
		flexDirection: 'column',
		textAlign: 'end'
	},
	icon: {
		cursor: 'pointer',
		marginTop: '18px',
		color: 'white',
	}
}))

interface MenuProps {
	onExit: () => void;
	isAdmin: boolean;
	players: PlayerMeta[];
	maxPlayers: number;
	onKick: (index: number) => void;
}

const Menu: FC<MenuProps> = ({ onExit, isAdmin, players, maxPlayers, onKick }) => {
	const classes = useStyles();
	const buttonClickAudio = useAudio(SOUNDS.BUTTON_CLICK, {});

	const [showRules, setShowRules] = useState(false);
	const [showList, setShowList] = useState(false);
	const [showAudioSettings, setShowAudioSettings] = useState(false);

	const closeAll = () => {
		setShowRules(false);
		setShowList(false);
		setShowAudioSettings(false);
		buttonClickAudio.play();
	};

	return (
		<Box className={classes.root}>
			<Box>
				<CancelIcon className={classes.icon} onClick={() => { onExit(); buttonClickAudio.play(); }} />
			</Box>
			<Box>
				<InfoIcon className={classes.icon}
					onClick={() => {
						closeAll();
						setShowRules(true);
					}}
				/>
				{showRules && <Rules onClose={closeAll} inline={false} />}
			</Box>
			{isAdmin && (
				<Box>
					<GroupIcon className={classes.icon}
						onClick={() => {
							closeAll();
							setShowList(true);
						}}
					/>
					{showList && <PlayerList onClose={closeAll} players={players} maxPlayers={maxPlayers} onKick={onKick} />}
				</Box>
			)}
			<Box>
				<AudioSettings isOpen={showAudioSettings} onClose={closeAll} onOpen={() => {
					closeAll();
					setShowAudioSettings(true);
				}} />
			</Box>
		</Box>
	);
};

export default Menu
